import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme:{
        themes:{
            light:{
                pending:"#FBAF3D",
                primary:"#00688F",
                secondary:'#3F3B3C',
                
            }
        }
    }
});
